module.exports = __webpack_public_path__ + "assets/344fcdc45aed9784bb4c40132f2101ef.svg";